export const Color = {
  blue: {
    25: "#F5FAFF",
    50: "#EFF8FF",
    75: "#E0F1FF",
    100: "#D1E9FF",
    200: "#B2DDFF",
    300: "#84CAFF",
    400: "#53B1FD",
    500: "#2E90FA",
    600: "#1570EF",
    700: "#175CD3",
    800: "#1849A9",
    900: "#194185",
  },
  gray: {
    25: "#FCFCFD",
    50: "#F9FAFB",
    100: "#F2F4F7",
    200: "#EAECF0",
    300: "#D0D5DD",
    400: "#98A2B3",
    500: "#667085",
    600: "#475467",
    700: "#344054",
    800: "#1D2939",
    900: "#101828",
  },
  error: {
    25: "#FFFBFA",
    50: "#FEF3F2",
    100: "#FEE4E2",
    200: "#FECDCA",
    300: "#FDA29B",
    400: "#F97066",
    500: "#F04438",
    600: "#D92D20",
    700: "#B42318",
    800: "#912018",
    900: "#7A271A",
  },
  success: {
    25: "#F6FEF9",
    50: "#ECFDF3",
    100: "#D1FADF",
    200: "#A6F4C5",
    300: "#6CE9A6",
    400: "#32D583",
    500: "#12B76A", // 🌟 основной (primary)
    600: "#039855", // hover
    700: "#027A48", // active
    800: "#05603A",
    900: "#054F31",
  },
  border: {
    secondary: "#E9EAEB",
    primary: "#D5D7DA",
  },
  text: {
    secondary: {
      "700": "#414651",
    },
    secaondaryHover: "#252B37",
    tertiary: {
      "600": "#535862",
    },
    quaternary: {
      "500": "#717680",
    },
  },
  brand: {
    solid: "#7F56D9",
    500: "#9E77ED",
    secondary: "#6941C6",
  },
};
